import AnnualReportSection from "./AnnualReportSection";
import ChiefExecutiveOfficerSection from "./ChiefExecutiveOfficerSection";
import ChiefFinancialofficerSection from "./ChiefFinancialOfficerSection";
import GovernanceAwardSection from "./GovernanceAwardSection";
import InvestorRelationsSection from "./InvestorRelationsSection";
import ManagedBoardSection from "./ManagedBoardSection";
import RiskManagementSection from "./RiskManagementSection";
import SpecialRecognitionAwardSection from "./SpecialRecognitionAwardSection";

/**
 * Component to render selections tab data in SCA how to nominate page
 */
const SelectionsPage = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="selections-page-component"
    >
      <ManagedBoardSection />

      <ChiefExecutiveOfficerSection />

      <ChiefFinancialofficerSection />

      <RiskManagementSection />

      <InvestorRelationsSection />

      <AnnualReportSection />

      <SpecialRecognitionAwardSection />

      <GovernanceAwardSection />
    </div>
  );
};

export default SelectionsPage;
